<template>
  <div class="kana">
   <div class="column" v-for="(col, index) in kana" :key="index">
     <div class="seion" v-for="kana in col" :key="kana[characterSet]"
      @click="kanaClicked(kana)"
      @mouseover="mouseover(kana, $event)" @mouseout="mouseout(kana, $event)"
      :class="{ selected: kana[characterSet] && kana.selected,
        correct: kana.correct, wrong: kana.wrong }">{{kana[characterSet]}}</div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'KanaChart',
  props: {
    kana: {
      type: Array
    },
    characterSet: {
      default: 'hiragana',
      type: String
    }
  },

  methods: {
    mouseover(kana, event) {
      if(kana.romaji && !kana.correct) {
        event.target.classList.add('hover');
      }
    },

    mouseout(kana, event) {
      event.target.classList.remove('hover');
    },

    kanaClicked(kana) {
      if(!this.firstSelection) {
        this.firstSelection = true;
        this.$emit('first-kana-selection');
      }
      this.$emit('kana-selected', { kana, characterSet: this.characterSet });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../styles/variables.less';


.kana {
  display: flex;
  flex-direction: row-reverse;

  .seion {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: @seion-font-size;
    padding: 3px;
    min-width: 85px;
    min-height: 85px;
    border: 1px solid @seion-border;
    margin-left: -1px;
    margin-bottom: -1px;
    transition: background-color ease-in .2s;
    color: @yankees-blue;

    &.correct {
      background-color: @kana-correct;
      color: @white;
    }

    &.selected {
      background-color: @kana-hover;
      color: @white;
    }

    &.wrong {
      color: @white;
      background-color: @kana-wrong;
      animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;

      @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
    }

    &.hover {
      background-color: @kana-hover;
      color: @white;
    }

    @media @smartphones, @tablets {
      min-width: 24px;
      min-height: 34px;
      font-size: 22px;
    }

    @media @landscape-tables-phones {
        min-width: 24px;
        min-height: 39px;
        font-size: 25px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/KanaChart.vue